import React, { PureComponent } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { get, filter } from "lodash";
import { onlyForCostNumbers, onlyNumbers } from "../../validation";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DatePicker } from "../../component";

export class PragatiReviewDates extends PureComponent {
  state = {
    pragatiReviewDates: [{}],
    error: [{}]
  };

  componentDidMount() {
    const { pragatiReviewDates } = this.props;
    let _pragatiReviewDates =
      pragatiReviewDates && pragatiReviewDates.length
        ? pragatiReviewDates.map((value, index) => {
            return {
              pragatiReviewDates: value
            };
          })
        : null;

    if (_pragatiReviewDates !== null) {
      this.setState({
        pragatiReviewDates: [..._pragatiReviewDates]
      });
    }
  }

  /*componentWillReceiveProps(nextProps, nextContext) {
        const {
            pragatiReviewDates,
            resetForm,
        } = nextProps;
        const { pragatiReviewDates: oldPragatiReviewDates } = this.props;

        debugger
            let _pragatiReviewDates = pragatiReviewDates && pragatiReviewDates.length ? pragatiReviewDates.map((value, index) => {
                return {
                    pragatiReviewDates: value
                };
            }) : {};

            this.setState({
                pragatiReviewDates: [..._pragatiReviewDates],
            });

        if (resetForm) {
            this.setState({
                pragatiReviewDates: [{}],
                error: [{}]
            });
        }
    }*/

  onRemoveDates = index => {
    const { updateParentState, updateParentStateError } = this.props;
    this.setState(prevState => {
      prevState.pragatiReviewDates.splice(index, 1);
      prevState.error.splice(index, 1);
      let _pragatiReviewDates =
        prevState.pragatiReviewDates &&
        prevState.pragatiReviewDates.length &&
        prevState.pragatiReviewDates.map(item => {
          return item.pragatiReviewDates;
        });
      updateParentState("pragatiReviewDates", _pragatiReviewDates);
      updateParentStateError("locations", prevState.error);
      return {
        pragatiReviewDates: [...prevState.pragatiReviewDates],
        error: [...prevState.error]
      };
    });
  };

  onAddDates = () => {
    const { updateParentState, updateParentStateError } = this.props;

    this.setState(
      prevState => {
        return {
          pragatiReviewDates: [{}, ...prevState.pragatiReviewDates],
          error: [{}, ...prevState.error]
        };
      },
      () => {
        let _pragatiReviewDates =
          this.state.pragatiReviewDates &&
          this.state.pragatiReviewDates.length &&
          this.state.pragatiReviewDates.map(item => {
            return item.pragatiReviewDates;
          });
        updateParentState("pragatiReviewDates", _pragatiReviewDates);
        updateParentStateError("pragatiReviewDates", this.state.error);
      }
    );
  };

  onChange = (value, key, index) => {
    const { updateParentState, updateParentStateError } = this.props;

    this.setState(prevState => {
      prevState.pragatiReviewDates[index] = {
        ...prevState.pragatiReviewDates[index],
        [key]: value
      };
      let _pragatiReviewDates =
        prevState.pragatiReviewDates &&
        prevState.pragatiReviewDates.length &&
        prevState.pragatiReviewDates.map(item => {
          return item.pragatiReviewDates;
        });
      updateParentState("pragatiReviewDates", _pragatiReviewDates);
      updateParentStateError("pragatiReviewDates", prevState.error);
      return {
        pragatiReviewDates: [...prevState.pragatiReviewDates],
        error: [...prevState.error]
      };
    });
  };

  render() {
    const { pragatiReviewDates } = this.state;

    const template = pragatiReviewDates.map((param, index) => {
      return (
        <React.Fragment>
          <div className={`added-location-wrapper added-date-wrapper`}>
            <div className="added-location-detail" style={{ width: "53.5%" }}>
              <div className="location-name">
                <Form.Group className="field-mscb">
                  <DatePicker
                    onChange={value =>
                      this.onChange(value, "pragatiReviewDates", index)
                    }
                    selected={get(param, "pragatiReviewDates", "")}
                    value={
                      this.props.disabled
                        ? ""
                        : get(param, "pragatiReviewDates", "")
                    }
                    // isClearable={get(this.state, "pragatiReviewDates")}
                    className="pragati-date"
                    isClearable={
                      get(param, "pragatiReviewDates") && !this.props.disabled
                    }
                    disabled={this.props.disabled}
                  />
                </Form.Group>
              </div>
            </div>
            {pragatiReviewDates && pragatiReviewDates.length ? (
              index === 0 ? (
                pragatiReviewDates.length && pragatiReviewDates.length < 10 ? (
                  <div
                    className="btn-icon add-more"
                    title="Add Dates"
                    onClick={this.props.disabled ? undefined : this.onAddDates}
                    style={{
                      pointerEvents: this.props.disabled ? "none" : "auto"
                    }}
                  >
                    +
                  </div>
                ) : (
                  <div
                    className="btn-icon delete-location"
                    title="Delete"
                    onClick={() =>
                      !this.props.disabled && this.onRemoveDates(index)
                    }
                    style={{
                      pointerEvents: this.props.disabled ? "none" : "auto"
                    }}
                  />
                )
              ) : (
                <div
                  className="btn-icon delete-location"
                  title="Delete"
                  onClick={() =>
                    !this.props.disabled && this.onRemoveDates(index)
                  }
                  style={{
                    pointerEvents: this.props.disabled ? "none" : "auto"
                  }}
                />
              )
            ) : null}
          </div>
        </React.Fragment>
      );
    });

    return (
      <React.Fragment>
        <div className="added-location">{template}</div>
        {/* <DisplayByPermission display={get(costError, "error")}>
                    <div className="location-cost-error">{get(costError, "message")}</div>
                </DisplayByPermission>*/}
      </React.Fragment>
    );
  }
}

export default PragatiReviewDates;
